module.exports = __webpack_public_path__ + "assets/img/8_1238_big.3e075efe.jpg";